module.exports = __webpack_public_path__ + "images/puzzle/Skeleton/PNG/Piece03.478714e1a33df6f83a3afafb386eaa14.png";